<template>
  <div>
    <div class="search-input">
      <v-icon @click="$emit('handleIconClick')">mdi-arrow-left</v-icon>
      <v-text-field
        @keydown.enter="$emit('handleOnEnter')"
        @input="val => $emit('getInputValue', val)"
        placeholder="Search Profile"
        solo
        class="search-bar-styling"
      />
    </div>
    <slot name="search-container-body"></slot>
  </div>
</template>

<script>
export default {
  name: 'SearchContainer'
}
</script>

<style>
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
}

.v-text-field.v-text-field--solo .v-input__control {
  height: 35px !important;
}
</style>

<style>
.search-input {
  border-bottom: 1px solid #eee;
  display: flex;
  padding: 10px 10px 10px 20px;
}
</style>
